import ActivityNote from "./ActivityNote";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/pro-solid-svg-icons";
import Replies from "../Replies.tsx";
import { ActivityReply } from "../../../../@types/activities.ts";

type ActivityQuestionArgs = {
  content?: string;
  activityId: string;
  answers: ActivityReply[];
  answer_count: number;
  closed: boolean;
  can?: { reply?: boolean };
  translated?: boolean;
  isHit?: boolean;
  showMoreButton?: boolean;
  readOnly?: boolean;
};

export default function ActivityQuestion({
  content,
  answers,
  answer_count,
  activityId,
  translated,
  closed,
  can,
  isHit = false,
  showMoreButton = true,
  readOnly = false,
}: ActivityQuestionArgs) {
  return (
    <div className="question-view">
      <div className="question-content-container mb-6">
        <span className="question-mark text-2xl!">
          <FontAwesomeIcon icon={faCircleQuestion} size="2x" />
        </span>
        <div className="flex-1 min-w-0 question-content">
          <ActivityNote
            content={content}
            translated={translated}
            showMoreButton={showMoreButton}
          />
        </div>
      </div>
      {!isHit && (
        <Replies
          activityId={activityId}
          replies={answers}
          repliesCount={answer_count}
          repliesClosed={closed}
          canReply={readOnly ? false : !!can?.reply}
          type="answers"
        />
      )}
    </div>
  );
}
